module.exports = __webpack_public_path__ + "static/media/neuland-n.aaf3d26c.svg";